export default {
 pageTitle: 'Legal Services',
 heroDesc: 'Professional legal services to escort your cross-border business',
 featuresTitle: 'Service Features',
 featuresSubtitle: 'Professional, rigorous, and global legal services',
 feature1Title: 'Professional Lawyers',
 feature1Desc: 'Top global lawyer team',
 feature2Title: 'Experienced',
 feature2Desc: '20+ years of cross-border legal service experience',
 feature3Title: 'Global Coverage',
 feature3Desc: 'Service network spanning 50+ countries',
 feature4Title: 'One-Stop Service',
 feature4Desc: 'Comprehensive legal solutions',
 viewDetails: 'View Details',
 service1Title: 'Legal Verification & Opinion',
 service1Subtitle: 'Professional Answering of Overseas Legal Issues',
 service1Desc: 'Enterprises may face a variety of overseas legal issues during their operations abroad. LEVIY, relying on its extensive global legal service network, can conduct legal verification for parties or domestic law firms in relevant countries and regions, and issue legal opinions on the relevant legal applicability issues and other issues of concern to clients.',
 service1Feature1Title: 'Legal Verification Services',
 service1Feature1Item1: 'Verification of overseas laws and regulations',
 service1Feature1Item2: 'Analysis of legal applicability',
 service1Feature1Item3: 'Research on laws and regulations in relevant countries and regions',
 service1Feature1Item4: 'Support for domestic law firms',
 service1Feature1Item5: 'Comparison of laws in multiple jurisdictions',
 service1Feature2Title: 'Legal Opinions',
 service1Feature2Item1: 'Issuance of professional legal opinions',
 service1Feature2Item2: 'Legal risk assessment',
 service1Feature2Item3: 'Compliance recommendations',
 service1Feature2Item4: 'Legal solutions',
 service2Title: 'Overseas Notarization',
 service2Subtitle: 'Global Notarization Services',
 service2Desc: 'At the request of Chinese judicial authorities, administrative agencies, or parties, LEVIY can handle notarization and certification of relevant evidence or documents abroad by government agencies, lawyers, notaries, and Chinese embassies and consulates abroad.',
 service2Feature1Title: 'Notarization Services',
 service2Feature1Item1: 'Government notarization services',
 service2Feature1Item2: 'Lawyer notarization services',
 service2Feature1Item3: 'Notary notarization',
 service2Feature1Item4: 'Notarization of various evidence and documents',
 service2Feature1Item5: 'Notarization of commercial documents',
 service2Feature2Title: 'Certification Services',
 service2Feature2Item1: 'Certification by Chinese embassies and consulates abroad',
 service2Feature2Item2: 'Consular certification services',
 service2Feature2Item3: 'Hague Apostille',
 service2Feature2Item4: 'Certification of document translation',
 service3Title: 'Due Diligence',
 service3Subtitle: 'Comprehensive Professional Due Diligence',
 service3Desc: 'Comprehensive due diligence on cooperation partners, partners, transaction counterparts, and the legal policies and related aspects of the destination country (region) for investment, trade, and services. LEVIY can conduct on-site inspections of the actual operating locations of companies to investigate and understand their operating background and current status, financial and credit status, on-site verification of employees and premises, etc. It can also be customized according to customer requirements to ensure the authority and accuracy of the investigation results.',
 service3Feature1Title: 'On-site Inspection and Investigation',
 service3Feature1Item1: 'On-site inspection of the actual operating location of the company',
 service3Feature1Item2: 'Investigation of operating background and current status',
 service3Feature1Item3: 'Verification of financial and credit status',
 service3Feature1Item4: 'On-site verification of employees and premises',
 service3Feature1Item5: 'Evaluation of business operations',
 service3Feature2Title: 'Legal Policy Investigation',
 service3Feature2Item1: 'Research on legal policies of the destination country (region)',
 service3Feature2Item2: 'Background investigation of cooperation partners and partners',
 service3Feature2Item3: 'Verification of the qualifications of transaction counterparts',
 service3Feature2Item4: 'Customized investigation plan',
 service3Feature2Item5: 'Authoritative and accurate investigation report',
 service4Title: 'Contract Drafting & Review',
 service4Subtitle: 'Chinese and English Commercial Contract Services',
 service4Desc: 'Outward-oriented enterprises need to sign various types of commercial contracts with cooperation partners during overseas investment and trade. Due to the differences in language and culture between the two parties and the differences in laws in different places, there may be certain risks. LEVIY customizes different commercial contracts (Chinese and English) for customers, reviews contracts, and helps customers secure reasonable rights to avoid unnecessary losses.',
 service4Feature1Title: 'Contract Drafting Services',
 service4Feature1Item1: 'Commercial contract drafting (Chinese)',
 service4Feature1Item2: 'Commercial contract drafting (English)',
 service4Feature1Item3: 'Customization of various commercial contracts',
 service4Feature1Item4: 'Compliance with local legal requirements',
 service4Feature1Item5: 'Protection of customer rights and interests',
 service4Feature2Title: 'Contract Review Services',
 service4Feature2Item1: 'Contract review and modification',
 service4Feature2Item2: 'Identification of legal risks',
 service4Feature2Item3: 'Suggestions for clause optimization',
 service4Feature2Item4: 'Securing reasonable rights',
 service4Feature2Item5: 'Avoiding unnecessary losses',
 service5Title: 'Property Investigation',
 service5Subtitle: 'Overseas Property Ownership Investigation',
 service5Desc: 'According to the requirements of the parties, LEVIY can investigate the overseas property of individuals and business organizations, including the property owner, property registration, property transfer, etc.',
 service5Feature1Title: 'Individual Property Investigation',
 service5Feature1Item1: 'Investigation of overseas individual property',
 service5Feature1Item2: 'Confirmation of property owner',
 service5Feature1Item3: 'Query of property registration status',
 service5Feature1Item4: 'Traceback of property history',
 service5Feature2Title: 'Business Organization Property Investigation',
 service5Feature2Item1: 'Investigation of overseas property of business organizations',
 service5Feature2Item2: 'Investigation of property transfer status',
 service5Feature2Item3: 'Analysis of property defects',
 service5Feature2Item4: 'Proof of property ownership',
 service6Title: 'Arbitration Enforcement',
 service6Subtitle: 'Overseas Arbitration and Litigation Services',
 service6Desc: 'According to the needs of the case, LEVIY can initiate arbitration or litigation procedures for the parties and apply to the relevant authorities in the location of the judgment debtor or the location of the execution property for enforcement, etc.',
 service6Feature1Title: 'Arbitration and Litigation',
 service6Feature1Item1: 'Initiate arbitration procedures',
 service6Feature1Item2: 'Initiate litigation procedures',
 service6Feature1Item3: 'Arbitration and litigation representation',
 service6Feature1Item4: 'Case strategy formulation',
 service6Feature2Title: 'Enforcement Services',
 service6Feature2Item1: 'Apply to relevant authorities for enforcement',
 service6Feature2Item2: 'Search for property of the judgment debtor',
 service6Feature2Item3: 'Follow-up on enforcement procedures',
 service6Feature2Item4: 'Design of enforcement plans',
 service7Title: 'General Legal Services',
 service7Subtitle: 'Comprehensive Legal Support',
 service7Desc: 'Various legal document preparation, legal letters, legal participation in negotiations and witnessing; legal services involving company law, securities law, investment law, banking law, immigration and labor law, environmental law, maritime law, etc.',
 service7Feature1Title: 'Legal Document Services',
 service7Feature1Item1: 'Preparation of various legal documents',
 service7Feature1Item2: 'Drafting and sending legal letters',
 service7Feature1Item3: 'Legal participation in negotiations',
 service7Feature1Item4: 'Legal witnessing services',
 service7Feature1Item5: 'Translation of legal documents',
 service7Feature2Title: 'Specialized Legal Services',
 service7Feature2Item1: 'Company legal services',
 service7Feature2Item2: 'Securities law, investment law services',
 service7Feature2Item3: 'Bank legal services',
 service7Feature2Item4: 'Immigration and labor law services',
 service7Feature2Item5: 'Environmental legal services',
 service7Feature2Item6: 'Maritime legal services',
}
